import React, { useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import Accordion from 'react-bootstrap/Accordion';


export default function CommentCaMarche() {
    

    return (
    <LayoutFrontend>   
          {/** Navbar Start */}
    <div className="container-fluid position-relative p-0">
    
                <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Comment ça marche</h1>
                    <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.homepage}>
                    Accueil
                    </Link>
                    <i className="far fa-circle text-white px-2"></i>
                    <Link className="h5 text-white" to={myroutes.comment_ca_marche}>
                    Comment ça marche
                    </Link>
                </div>
            </div>
        </div>
    </div>
     {/** Navbar End */}
     <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-8">
                            <h1 className="mb-0" style={{ fontSize: "32px" }}>Questions Fréquentes</h1>  
                            </div>
                            <div className="col-md-2">
                            </div>
                        </div>
                    </div>
                </div>
    <div className="container">
        <div className="row">
        <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
            <Accordion.Header >Dgbook, c'est quoi? Comment peut-il aider dans la vie quotidienne ? </Accordion.Header>
            <Accordion.Body>
            Tout d'abord, il faut savoir que Dgbook est une plateforme qui peut contenir des documents numériques, ce qui permet de conserver ces documents, de les protéger,
            dans un espace sécurisé où l'on peut avoir facilement accès, juste en clic avec l'un des terminaux suivants : 
            PC, smartphones, tablettes, portables..... 
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
            <Accordion.Header>Comment avoir accès à ces documents ?</Accordion.Header>
            <Accordion.Body>
           Il faut se rendre sur <span style={{color:"#1C95FF"}}>https://www.dgbook.africa/</span> , choisir un ou plusieurs publications de notre choix,
            consulter notre panier, valider le panier, ensuite la commande puis valider le paiement pour avoir accès aux documents dans notre compte, ainsi tu peux lire tes documents où et quand tu veux. <br />
            <span style={{color:"red"}}>Attention : </span>  <span style={{fontStyle:"italic"}}>Notez bien qu'il faut veiller à avoir un compte si ce n'est pas le cas et se connecter pour valider son paiement.  </span>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
            <Accordion.Header>Pourquoi il est important d'avoir un compte sur la plateforme?</Accordion.Header>
            <Accordion.Body>
            Il faut savoir que sans s'inscrire tu peux consulter , rechercher des documents de ton choix et avoir plus d'informations sur ces documents mais tu ne peux lire ces documents sans avoir un compte sur la plateforme, cela permet de suivre le flux 
            d'échanges sur la plateforme web et d'assurer la tracabilité en cas de dommages (piratages, hacking.......).
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
            <Accordion.Header>Que faire lorsque les documents disparaissent subitement de mon compte ?</Accordion.Header>
            <Accordion.Body>
           Lorsque les publications de mon compte s'affichent pas  , cela suppose que  la session de connexion a expirée , donc il faut veiller à se déconnecter et se reconnecter pour avoir accès à nouveau à tous mes documents . <br />
           <span style={{color:"red"}}>NB :</span>  <span style={{fontStyle:"italic", }}>En cas de soucis majeurs ou pour plus d'informations, veuillez contacter le support technique au <span style={{color:"#1C95FF"}}> +229 69 61 99 99</span> ou par notre adresse mail <span style={{color:"#1C95FF"}}> sales@dgbook.africa</span>, ou tout simplement nous envoyer un message via la page de contact.</span>
            </Accordion.Body>
        </Accordion.Item>
        </Accordion>
        </div>
    </div>
    </LayoutFrontend>
   
   )
}